import fetch from "@/utils/fetch";

/**
 * 获取型号详细信息
 */
const getModelTypeInfo = (params) => {
    return fetch({
        url: "/h5/getModelTypeInfo",
        method: "post",
        data: params,
    });
};
/**
 *  获取轮播图列表
 */
const getSlideshowList = function (data) {
    return fetch({
        url: "/h5/getSlideshowList",
        method: "post",
        data: data,
        headers: {
            "Content-Type": "application/json",
        },
    });
};

/**
 * 获取产品列表
 */
const getProductList = (params) => {
    return fetch({
        url: "/h5/getProductList",
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
        },
    });
};
/**
 * 获取公共信息接口-帮助支持/关注我们
 */
const getPublicResourceInfo = (params) => {
    return fetch({
        url: "/h5/getPublicResourceInfo",
        method: "post",
        data: params,
        headers: {
            "Content-Type": "application/json",
        },
    });
};

/**
 * 获取型号列表
 */
const getModelTypeList = (params) => {
    return fetch({
        url: "/h5/getModelTypeList",
        method: "post",
        data: params,
    });
};
/**
 * 获取类目列表
 */
const getCategoryList = (params) => {
    return fetch({
        url: "/h5/getCategoryList",
        method: "post",
        data: params,
    });
};
/**
 * 搜索型号
 */
const searchModelTypeList = (params) => {
    return fetch({
        url: "/h5/searchModelTypeList",
        method: "post",
        data: params,
    });
};
const apiList = {
    getModelTypeInfo,
    getSlideshowList,
    getProductList,
    getPublicResourceInfo,
    getModelTypeList,
    getCategoryList,
    searchModelTypeList,
};

export default apiList;



// WEBPACK FOOTER //
// ./src/api/api.js